import { UserListItemContent } from '../../ListItem'
import { MultiValuedListMoreItem } from '../../MultiValuedList'

import { USER_MULTI_VALUE_LIST_MORE_ITEM_AVATAR_SIZE } from './UserMultiValuedListMoreItem.constants'

import * as styles from './UserMultiValuedListMoreItem.module.css'

function UserMultiValuedListMoreItem({
  Icon,
  avatarSize = USER_MULTI_VALUE_LIST_MORE_ITEM_AVATAR_SIZE,
  className = styles.UserMultiValuedListMoreItem,
  ref,
  user,
  ...itemProps
}) {
  return (
    <MultiValuedListMoreItem {...itemProps} className={className} ref={ref}>
      <UserListItemContent Icon={Icon} avatarSize={avatarSize} value={user} />
    </MultiValuedListMoreItem>
  )
}

export default UserMultiValuedListMoreItem
